import { type CostBasisPosition } from '@interfaces/cost-basis/cost-basis.service.interface';
import { type FilteredCostBasisCoveredLot } from '@interfaces/cost-basis/cost-basis.service.interface';
import { CostBasisMethods, FlowTypes } from '@interfaces/models';

import { parseStr, parseStrDefaultToZero } from './money.helpers';

export function getTaxLotsAmount(
  giftingMethod: string,
  taxLot: FilteredCostBasisCoveredLot,
): number {
  return giftingMethod === 'SHARES' ? taxLot.quantity : taxLot.marketValue;
}

export function getTotalAmountForPosition(
  position: CostBasisPosition,
  flowType: FlowTypes,
): number | undefined {
  switch (flowType) {
    case FlowTypes.GIFTING: {
      let amount: string | undefined = String(position.selectedAmount);
      if (position.selectedCostBasisMethod === CostBasisMethods.SPECID) {
        amount =
          position.giftingMethod === 'SHARES'
            ? position.taxLotsTotalShares
            : position.taxLotsTotalMarketValue;
      }
      return parseStr(amount);
    }
    case FlowTypes.INTERNAL_TRANSFER: {
      return Number(position.estValueOfTransfer);
    }
    default: {
      throw new Error(`Unsupported flow type: ${flowType}`);
    }
  }
}

// Feel free to add types/cases here as needed
export type NumConversionTypes = string | number | undefined | null;

/**
 * Converts various types to a number, defaulting to 0 for undefined or empty strings.
 */
export const toNumber = (value: NumConversionTypes): number => {
  if (value === null) return 0;
  switch (typeof value) {
    case 'number':
      return value;
    case 'string':
      // Empty string defaults to 0
      return parseStrDefaultToZero(value);
    case 'undefined':
      return 0;
    default:
      const _: never = value;
      return 0;
  }
};
